// Header inline menu hover -- guard against pages without this element
const menuEl = document.querySelector(".header__inline-menu");
if (menuEl) {
  let items = menuEl.querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  });
}

jQuery(document).ready(function(){
  jQuery('.testimonials-section .testimonials-slider').owlCarousel({
    loop: true, nav: false, dots: false, autoplay: false,
    autoplayTimeout: 4000, autoplayHoverPause: true, margin: 0, items: 4,
    responsive: { 0: { items: 1 }, 577: { items: 2, margin: 30 }, 990: { items: 3, margin: 60 } }
  });
});

jQuery(document).ready(function () {
  setTimeout(function () {
    const wordLimit = 25;
    function truncateAndToggleContent() {
      jQuery('.custom_four_section .sectiondiv .contentss p').each(function () {
        const $this = jQuery(this);
        const content = $this.text();
        const words = content.trim().split(/\s+/);
        if (words.length > wordLimit) {
          const truncatedContent = words.slice(0, wordLimit).join(' ') + '...';
          $this.data('originalText', content);
          $this.text(truncatedContent);
          const $btn = jQuery('<a class="read-more-btn">Read More</a>');
          $this.after($btn);
          $btn.on('click', function () {
            if ($this.text() === truncatedContent) { $this.text($this.data('originalText')); $btn.text('Read Less'); }
            else { $this.text(truncatedContent); $btn.text('Read More'); }
          });
        }
      });
    }
    truncateAndToggleContent();
    jQuery(window).on('resize', truncateAndToggleContent);
  }, 1000);
});

// FAQ accordion -- guard against pages without these elements
const accordionItems = document.querySelectorAll('.shopify_explorer_faq__item');
accordionItems.forEach(item => {
  const h3 = item.querySelector('.shopify_explorer_faq__item h3');
  const content = item.querySelector('.shopify_explorer_faq__item .content_element');
  if (h3 && content) {
    h3.addEventListener('click', () => {
      accordionItems.forEach(other => {
        const oc = other.querySelector('.shopify_explorer_faq__item .content_element');
        if (other !== item && oc) oc.classList.remove('open');
      });
      content.classList.toggle('open');
    });
  }
});

jQuery(document).ready(function() {
  jQuery("input[type='tel']").bind({ keydown: function(e) {
    if (e.shiftKey) { return e.which == 9; }
    if (e.which > 57) { return e.which >= 96 && e.which <= 105; }
    return e.which != 32;
  }});
});

// Tab UI -- guard against pages without tab elements
window.addEventListener('load', function() {
  const tabs = document.querySelectorAll('.tab-item');
  const panes = document.querySelectorAll('.tab-pane');
  if (!tabs.length) return;
  tabs.forEach(function(tab, index) {
    const pane = panes[index];
    if (!pane) return;
    tab.addEventListener('click', function() {
      const ap = document.querySelector('.tab-pane.active');
      const at = document.querySelector('.tab-item.active');
      if (ap) ap.classList.remove('active');
      if (at) at.classList.remove('active');
      pane.classList.add('active');
      tab.classList.add('active');
    });
  });
});

jQuery('.js-load-more').on('click', function() {
  var $this = jQuery(this),
    totalPages = parseInt(jQuery('[data-all-pages]').val()),
    currentPage = parseInt(jQuery('[data-this-page]').val()),
    datacollurl = jQuery('[data-coll-url]').val();
  $this.attr('disabled', true);
  $this.find('[load-more-text]').addClass('hide');
  $this.find('[loader]').removeClass('hide');
  var nextUrl = jQuery('[data-next-link]').val();
  var cpn = currentPage + 1, nc = currentPage + 2;
  jQuery.ajax({ url: nextUrl, type: 'GET', dataType: 'html',
    success: function(html) {
      jQuery('[data-next-link]').val(datacollurl + '?page=' + nc);
      jQuery('[data-this-page]').val(cpn);
      jQuery('.grid-loader').append(jQuery(html).find('.grid-loader').html());
    },
    complete: function() {
      if (cpn < totalPages) { $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide'); }
      if (cpn >= totalPages) { $this.addClass('button_hide'); $this.find('[loader]').addClass('hide'); }
    }
  });
});

jQuery(document).ready(function() {
  jQuery(window).scroll(function() {
    jQuery('body .header-wrapper').toggleClass('active', jQuery(this).scrollTop() > 100);
  });
  jQuery('input[type="email"]').on('input', function() {
    jQuery(this).val(function(_, v) { return v.toLowerCase(); });
  });
});
